import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/home/Home.vue'
import Service from '../views/home/detail/Home.vue'
import Match from '../views/match/Home.vue'
import MatchDetail from '../views/match/Detail.vue'
import MatchAgency from '../views/match/Agency.vue'
import MatchGame from '../views/match/Game.vue'
import MatchLoopScore from '../views/match/LoopScore.vue'
import MatchLoopRank from '../views/match/LoopRank.vue'
import MatchLoopCard from '../views/match/LoopCard.vue'
import MatchRank from '../views/match/Rank.vue'
import AgencyDetail from '../views/match/AgencyDetail.vue'
import Join from '../views/match/join/Join.vue'
import Referee from '../views/match/referee/Referee.vue'
import Center from '../views/center/Index.vue'
import CenterAgency from '../views/center/Agency.vue'
import MatchNotice from '../views/match/Notice.vue'
import MatchNoticeDetail from '../views/match/NoticeDetail.vue'
import Event from '../views/event/EventHome.vue'
import ProductCenter from '../views/product/Home.vue'
import MatchCenter from '../views/matchcenter/Home.vue'

import Program from '../views/program/ProgramIndex.vue'
import ProgramRank from '../views/program/ProgramRank.vue'
import PlayerDetail from '../views/program/ProgramPlayerDetail.vue'
import ProgramAgency from '../views/program/ProgramAgency.vue'
import ProgramMatch from '../views/program/ProgramMatch.vue'
import ActivityIndex from '../views/program/ActivityIndex.vue'
import ProgramReferee from '../views/program/ProgramReferee.vue'
import ActivitySign from '../views/program/ActivitySign.vue'
import ActivitySchedule from '../views/program/ActivitySchedule.vue'
import ActivityLecturer from '../views/program/ActivityLecturer.vue'
import ActivityNotice from '../views/program/ActivityNotice.vue'
import ActivityCheck from '../views/program/ActivityCheck.vue'
import ActivityAnswer from '../views/program/ActivityAnswer.vue'
import Activity from '../views/layout/Activity.vue'
import Rank from '../views/layout/Rank.vue'
import Agency from '../views/layout/Agency.vue'
import Stadium from '../views/stadium/Home.vue'
import Organizing from '../views/organizing/Home.vue'
import OrganizingPlayer from '../views/organizing/Player.vue'
import OrganizingStaff from '../views/organizing/Staff.vue'
import OrganizingReferee from '../views/organizing/Referee.vue'

import BasketBall from '../views/match/backetball/home.vue'
import VolleyBall from '../views/match/volleyball/home.vue'

import PhysicalFitnessResult from '@comm/components/PhysicalFitness/Result.vue' //体能成绩公示
import PhysicalFitnessRank from '@comm/components/PhysicalFitness/Rank.vue' //体能排行榜
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '',
      },
    },
    {
      path: '/rank',
      name: 'Rank',
      component: Rank,
      meta: {
        title: '运动员排行榜',
      },
    },
    {
      path: '/agency',
      name: 'Agency',
      component: Agency,
      meta: {
        title: '机构排行榜',
      },
    },
    {
      path: '/stadium',
      name: 'Stadium',
      component: Stadium,
      children: [
        {
          path: '/',
          name: 'SubHome',
          meta: {
            title: '场馆',
          },
          component: () => import('@/views/stadium/components/home/Home'),
        },
        {
          path: '/parvialhome',
          name: 'ParvialHome',
          meta: {
            title: '场馆详情页',
          },
          component: () => import('@/views/stadium/components/ParvialHome'),
        },
        {
          path: '/course',
          name: 'CourseDescription',
          meta: {
            title: '场馆课程介绍',
          },
          component: () => import('@/views/stadium/components/course/CourseDescription'),
        },
        {
          path: '/booking',
          name: 'Booking',
          meta: {
            title: '场馆订场',
          },
          component: () => import('@/views/stadium/components/booking/Booking'),
        },
        {
          path: '/coursedetail',
          name: 'ListerCourseDetail',
          meta: {
            title: '场馆订场',
          },
          component: () => import('@/views/stadium/components/parvial/ListerCourseDetail'),
        },
        {
          path: '/photodetail',
          name: 'PhotoDetail',
          meta: {
            title: '场馆相册',
          },
          component: () => import('@/views/stadium/components/parvial/PhotoDetail'),
        },
        {
          path: '/teacherlist',
          name: 'TeacherList',
          meta: {
            title: '场馆-名师团队',
          },
          component: () => import('@/views/stadium/components/parvial/TeacherList'),
        },
      ],
    },
    {
      path: '/service',
      name: 'Service',
      component: Service,
      meta: {
        title: '服务流程 ',
      },
    },
    {
      path: '/Match',
      name: 'Match',
      component: Match,
      meta: {
        title: '赛事专区 ',
      },
    },
    {
      path: '/Activity',
      name: 'Activity',
      component: Activity,
      meta: {
        title: '活动专区 ',
      },
    },
    {
      path: '/MatchDetail',
      name: 'MatchDetail',
      component: MatchDetail,
      meta: {
        title: '赛事主页 ',
      },
    },
    {
      path: '/productCenter',
      name: 'ProductCenter',
      component: ProductCenter,
      meta: {
        title: '产品中心 ',
      },
    },
    {
      path: '/MatchAgency',
      name: 'MatchAgency',
      component: MatchAgency,
      meta: {
        title: '参赛数据 ',
      },
    },
    {
      path: '/MatchGame',
      name: 'MatchGame',
      component: MatchGame,
      meta: {
        title: '场次对战 ',
      },
    },
    {
      path: '/MatchLoopScore',
      name: 'MatchLoopScore',
      component: MatchLoopScore,
      meta: {
        title: '积分榜 ',
      },
    },
    {
      path: '/MatchLoopRank',
      name: 'MatchLoopRank',
      component: MatchLoopRank,
      meta: {
        title: '射手榜 ',
      },
    },
    {
      path: '/MatchLoopCard',
      name: 'MatchLoopCard',
      component: MatchLoopCard,
      meta: {
        title: '红黄牌榜 ',
      },
    },
    {
      path: '/MatchRank',
      name: 'MatchRank',
      component: MatchRank,
      meta: {
        title: '奖牌榜 ',
      },
    },
    {
      path: '/AgencyDetail',
      name: 'AgencyDetail',
      component: AgencyDetail,
      meta: {
        title: '参赛数据详情 ',
      },
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join,
      meta: {
        title: '赛事报名 ',
      },
    },
    {
      path: '/Referee',
      name: 'Referee',
      component: Referee,
      meta: {
        title: '裁判员报名 ',
      },
    },
    {
      path: '/Center',
      name: 'Center',
      component: Center,
      meta: {
        title: '个人中心 ',
        breadcrumb: [
          {
            url: '/Center',
            name: '个人中心 ',
          },
        ],
      },
    },
    {
      path: '/CenterAgency',
      name: 'CenterAgency',
      component: CenterAgency,
      meta: {
        title: '机构管理 ',
        breadcrumb: [
          {
            url: '/Center',
            name: '个人中心 ',
          },
          {
            url: '/CenterAgency',
            name: '机构管理',
          },
        ],
      },
    },
    {
      path: '/MatchNotice',
      name: 'MatchNotice',
      component: MatchNotice,
      meta: {
        title: '赛事公告 ',
      },
    },
    {
      path: '/MatchNoticeDetail',
      name: 'MatchNoticeDetail',
      component: MatchNoticeDetail,
      meta: {
        title: '赛事公告详情 ',
      },
    },
    {
      path: '/Event',
      name: 'Event',
      component: Event,
      meta: {
        title: '项目专区 ',
      },
    },
    {
      path: '/Program',
      name: 'Program',
      component: Program,
      meta: {
        title: '项目专区 ',
      },
    },
    {
      path: '/ProgramRank',
      name: 'ProgramRank',
      component: ProgramRank,
      meta: {
        title: '运动员榜 ',
      },
    },
    {
      path: '/PlayerDetail',
      name: 'PlayerDetail',
      component: PlayerDetail,
      meta: {
        title: '运动员详情 ',
      },
    },
    {
      path: '/ProgramAgency',
      name: 'ProgramAgency',
      component: ProgramAgency,
      meta: {
        title: '机构榜 ',
      },
    },
    {
      path: '/ProgramMatch',
      name: 'ProgramMatch',
      component: ProgramMatch,
      meta: {
        title: '赛事专区 ',
      },
    },
    {
      path: '/ActivityIndex',
      name: 'ActivityIndex',
      component: ActivityIndex,
      meta: {
        title: '教练培训 ',
      },
    },
    {
      path: '/ProgramReferee',
      name: 'ProgramReferee',
      component: ProgramReferee,
      meta: {
        title: '裁判培训 ',
      },
    },
    {
      path: '/ActivitySign',
      name: 'ActivitySign',
      component: ActivitySign,
      meta: {
        title: '教练培训 ',
      },
    },
    {
      path: '/ActivitySchedule',
      name: 'ActivitySchedule',
      component: ActivitySchedule,
      meta: {
        title: '日程安排 ',
      },
    },
    {
      path: '/ActivityLecturer',
      name: 'ActivityLecturer',
      component: ActivityLecturer,
      meta: {
        title: '培训讲师 ',
      },
    },
    {
      path: '/ActivityNotice',
      name: 'ActivityNotice',
      component: ActivityNotice,
      meta: {
        title: '通知公告 ',
      },
    },
    {
      path: '/ActivityCheck',
      name: 'ActivityCheck',
      component: ActivityCheck,
      meta: {
        title: '考试 ',
      },
    },
    {
      path: '/ActivityAnswer',
      name: 'ActivityAnswer',
      component: ActivityAnswer,
      meta: {
        title: '答题 ',
      },
    },
    {
      path: '/MatchCenter',
      name: 'MatchCenter',
      component: MatchCenter,
      meta: {
        title: '赛事中心',
      },
    },
    {
      path: '/BasketBall',
      name: 'BasketBall',
      component: BasketBall,
    },
    {
      path: '/VolleyBall',
      name: 'VolleyBall',
      component: VolleyBall,
    },
    {
      path: '/Organizing',
      name: 'Organizing',
      component: Organizing,
    },
    {
      path: '/OrganizingPlayer',
      name: 'OrganizingPlayer',
      component: OrganizingPlayer,
    },
    {
      path: '/OrganizingStaff',
      name: 'OrganizingStaff',
      component: OrganizingStaff,
    },
    {
      path: '/OrganizingReferee',
      name: 'OrganizingReferee',
      component: OrganizingReferee,
    },
    {
      path: '/PhysicalFitnessResult',
      name: 'PhysicalFitnessResult',
      component: PhysicalFitnessResult,
    },
    {
      path: '/PhysicalFitnessRank',
      name: 'PhysicalFitnessRank',
      component: PhysicalFitnessRank,
    },
  ],
})
//路由重复报错问题处理
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default router



// WEBPACK FOOTER //
// ./src/daoba-match/router/index.js